import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef } from "@angular/material/dialog";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AngularFireDatabase } from "angularfire2/database-deprecated";
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html'
})
export class DialogComponent implements OnInit {
  type: any;


  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    private afs: AngularFirestore,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.type = data;
    console.log(data);
  }

  ngOnInit() {


  }

  censorPost(): void {
    this.afs.collection('posts').doc(this.data.key).update({ isCensor: true });
    this.dialogRef.close();


  }

  close() {
    this.dialogRef.close();
  }


}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/userlist-photo/dialog/dialog.component.ts